/* global Swiper, attachEvent */
const relatedJobsElements = document.querySelectorAll('[data-slider="related-jobs__slider"]');

// *******************************************************************************
// Related jobs slider
// *******************************************************************************

Array.prototype.forEach.call(relatedJobsElements, (el) => {
  const relatedJobsSliderParent = el.closest('.related-jobs');
  const arrowRight = relatedJobsSliderParent.querySelectorAll('.arrow--right');
  const arrowLeft = relatedJobsSliderParent.querySelectorAll('.arrow--left');

  const relatedJobsOptions = {
    slidesPerView: 'auto',
    spaceBetween: 12,
    speed: 400,
    navigation: {
      nextEl: arrowRight,
      prevEl: arrowLeft,
    },
    pagination: {
      el: '.related-jobs__slider-counter',
      type: 'custom',
      renderCustom(swiper, current, total) {
        return `${`0${current}`.slice(-2)} / <span class="total-slides">${`0${total}`.slice(-2)}</span>`;
      },
    },
    breakpoints: {
      768: {
        slidesPerView: '2',
      },
      1023: {
        slidesPerView: 'auto',
      },
    },
  };

  // eslint-disable-next-line no-unused-vars
  const relatedJobs = new Swiper(el, relatedJobsOptions);
});

// *******************************************************************************
// Next step
// *******************************************************************************
if (document.querySelector('.btn-next-quiz')) {
  let clicksBtnNumber = 0;
  let points = 0;
  attachEvent('.btn-next-quiz', 'click', (ev) => {
    const parentStepElement = ev.target.closest('.quiz-step');
    const nextStep = parentStepElement.nextElementSibling;
    if (ev.target.closest('a').classList.contains('btn-for-point')) {
      // eslint-disable-next-line no-plusplus
      points++;
    }
    if (!nextStep.classList.contains('quiz-step--result')) {
      // Fade next section
      parentStepElement.classList.remove('is-active');
      nextStep.classList.add('is-active');
      if (nextStep.classList.contains('quiz-video')) {
        const videoElement = nextStep.querySelector('.quiz-video__bgvideo');
        videoElement.play();
        const parentVideoStep = document.querySelector('.quiz-step.is-active');

        // Show title 2 seconds before video ends
        const showTitle = `${Math.round(videoElement.duration) - 2}000`;
        window.setTimeout(() => {
          parentVideoStep.classList.add('show-title');
        }, showTitle);

        // Fade next step after video ends
        videoElement.onended = function () {
          const nextQuiz = parentVideoStep.nextElementSibling;
          document.getElementById('progress-bar').style.width = `${clicksBtnNumber * 6.25}%`;
          clicksBtnNumber++;

          window.setTimeout(() => {
            parentVideoStep.classList.remove('is-active');
            nextQuiz.classList.add('is-active');
            nextStep.classList.remove('show-title');
          }, 1000);
        };
      }
    } else {
      parentStepElement.classList.remove('is-active');
      const results = document.querySelectorAll('.quiz-step--result');
      results.forEach((i) => {
        // eslint-disable-next-line radix
        if (parseInt(i.dataset.point) <= points && parseInt(i.dataset.top) >= points) {
          i.classList.add('is-active');
        }
        // eslint-disable-next-line no-param-reassign
        i.querySelector('.results-score').innerText = points;
      });
    }
    document.getElementById('progress-bar').style.width = `${clicksBtnNumber * 6.25}%`;
    // eslint-disable-next-line no-plusplus
    clicksBtnNumber++;
  });
}
